(window as any).global = window;
// Prevent zone.js from crashing when an unhandled promise rejection is a frozen object
// (e.g. Apollo Client cache errors or NgRx state objects). 
// By setting this to false, Zone.js will wrap the rejection in an Error object instead of 
// trying to mutate the original frozen object (which throws "object is not extensible").
(window as any).__zone_symbol__DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION = false;
